<div [formGroup]="form" class="py-2 px-6">
  <div class="flex justify-between gap-4 items-center">
    <mat-form-field
      class="input-tg mt-message-input w-2/4"
      appearance="outline"
    >
      <mat-label>Descrição</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>

    <mat-slide-toggle class="w-1/4" formControlName="active">{{
      form.get('active')?.value ? 'Ativo' : 'Inativo'
    }}</mat-slide-toggle>
    <button
      mat-flat-button
      class="btn-tg w-1/4"
      [disabled]="form.invalid || loading"
      (click)="createAddressType()"
    >
      @if (loading) {
        <mat-spinner
          diameter="22"
          class="loading-spinner"
          selected-track-color="red"
        ></mat-spinner>
      } @else {
        Adicionar Novo
      }
    </button>
  </div>
  <!--  <button mat-flat-button class="btn-tg w-full mt-6" [disabled]="!checkForm()" (click)="sendLogin()">entrar</button>-->
</div>
